// 로컬
// export const SERVER_HOST = "https://localhost:8080";

// 개발
// export const SERVER_HOST = "https://qrtest.gongbbu.com";
// export const NICE_PAY_MID = "nictest00m";

// 운영
export const SERVER_HOST = "https://qr.gongbbu.com";
export const NICE_PAY_MID = "gongbbu01m"; // 운영 상점ID 


export const SERVER_URL = `${SERVER_HOST}/api`
// NicePay 연동
export const NICE_PAY_REQUEST_URL = "https://web.nicepay.co.kr/v3/v3Payment.jsp"
export const NICE_PAY_RETURN_URL = `${SERVER_HOST}/nicepay/payResult`